// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Badge } from "@/components/ui/badge";
// // import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
// import {
//   Sheet,
//   SheetContent,
//   SheetHeader,
//   SheetTitle,
//   SheetTrigger,
// } from "@/components/ui/sheet";

// import { createPageUrl } from "@/utils";
// import { base44 } from "@/api/base44Client"; 
// import { useAuth } from "@/auth/AuthContext"; 
// import { useQuery, useQueryClient } from "@tanstack/react-query";
// import { getTranslation } from "@/components/utils/translations";

// import {
//   Home, Search, ShoppingCart, Bell, Menu, X, Package, Truck, Tag, Star,
//   AlertTriangle, Sparkles, Wrench, ClipboardList, Trash2, RotateCcw,
//   Building2, Grid3X3, ChevronLeft, LogOut, FileText, Users, Wallet, Settings
// } from "lucide-react";

// import { Button } from "@/components/ui/button";
// // import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

// export default function Layout({ children, currentPageName }) {
//   const queryClient = useQueryClient();
//   const { user: currentUser, logout } = useAuth(); 

//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [categoriesOpen, setCategoriesOpen] = useState(false);

//   const [language, setLanguage] = useState("he");

//   const t = (key) => getTranslation(language, key);

//   const roleKey = currentUser?.role?.key || currentUser?.role;
//   const isSuperAdminUser = currentUser?.isSuperAdmin === true || roleKey === 'SUPER_ADMIN' || roleKey === 'admin';
//   const isSystemAdmin = isSuperAdminUser || roleKey === 'SYSTEM_ADMIN' || currentUser?.custom_role === 'system_admin';
//   const isStoreManager = roleKey === 'SUPER_MANAGER' || currentUser?.custom_role === 'store_manager';
//   const isAreaManager = roleKey === 'AREA_MANAGER' || currentUser?.custom_role === 'area_manager';


//   const { data: notifications = [] } = useQuery({
//     queryKey: ['notifications'],
//     queryFn: async () => {
//         try {
//             return await base44.entities.Notification.list();
//         } catch (e) { return []; }
//     },
//     enabled: !!currentUser, // רק אם מחובר
//     refetchInterval: 30000, // רענון כל 30 שניות
//   });

//   // חישוב מספר ההודעות שלא נקראו
//   const unreadCount = notifications.filter(n => !n.is_read).length;
//   const { data: userStore } = useQuery({
//     queryKey: ['myStore', currentUser?.store_id],
//     queryFn: async () => {
//         // טיפול במקרה ש-store_id הוא אובייקט (populated) או מחרוזת
//         const storeId = typeof currentUser?.store_id === 'object' ? currentUser.store_id._id : currentUser?.store_id;
//         if (!storeId) return null;
//         try {
//             return await base44.entities.Store.get(storeId);
//         } catch (e) { return null; }
//     },
//     enabled: !!currentUser?.store_id && !isSystemAdmin 
//   });

//   const { data: userChain } = useQuery({
//     queryKey: ['myChain', userStore?.chain_id],
//     queryFn: async () => {
//         const chainId = typeof userStore?.chain_id === 'object' ? userStore.chain_id._id : userStore?.chain_id;
//         if (!chainId) return null;
        
//         try {
//             const chains = await base44.entities.Chain.list(); 
//             return chains.find(c => (c.id || c._id) === chainId);
//         } catch (e) { return null; }
//     },
//     enabled: !!userStore,
//     staleTime: 1000 * 60 * 30 
//   });

//   const getMenuItems = () => {
//     return [
//       { name: t("home"), page: "Home", icon: Home },
//       { name: t("storeProducts"), page: "StoreProducts", icon: Package },
//       { name: t("productSearch"), page: "ProductSearch", icon: Search },
//       { name: t("categories"), page: "Categories", icon: Grid3X3 },
//       { name: t("companies"), page: "Companies", icon: Building2 },
//       { name: t("suppliers"), page: "Suppliers", icon: Truck },
//       { name: t("promotions"), page: "Promotions", icon: Tag },
//       { name: t("brochures"), page: "Brochures", icon: FileText },
//       { name: t("promotionImplementation"), page: "PromotionImplementation", icon: Tag },
//       { name: t("recommendations"), page: "Recommendations", icon: Star },
//       { name: t("mustOrder"), page: "MustOrder", icon: AlertTriangle },
//       { name: t("newProducts"), page: "NewProducts", icon: Sparkles },
//       { name: t("slowMovingProducts"), page: "SlowMovingProducts", icon: ClipboardList },
//       { name: t("orders"), page: "Orders", icon: Package },
//       { name: t("serviceRequests"), page: "ServiceRequests", icon: Wrench },
//       { name: t("inventoryCount"), page: "InventoryCount", icon: ClipboardList },
//       { name: t("safeCount"), page: "SafeCount", icon: Wallet },
//       { name: t("notifications"), page: "Notifications", icon: Bell },
//       { name: t("destructions"), page: "Destructions", icon: Trash2 },
//       { name: t("returns"), page: "Returns", icon: RotateCcw },
      
//     ];
//   };

//   const getMenuItemsForUser = () => {
//     let baseItems = [...getMenuItems()];

//     if (isSystemAdmin) {
//       baseItems = baseItems.filter(item => 
//         !["ProductSearch", "StoreProducts", "NewProducts", "InventoryCount", "SafeCount"].includes(item.page)
//       );
      
//       const items = [...baseItems];
//       items.splice(1, 0, { name: t("products"), page: "Products", icon: Package });

//       const promotionImplIndex = items.findIndex(item => item.page === "PromotionImplementation");
//       if (promotionImplIndex !== -1) {
//         items.splice(promotionImplIndex + 1, 0, { name: t("manageInventoryCounts"), page: "ManageInventoryCounts", icon: ClipboardList });
//       }

//       return [
//         ...items,
//         { name: t("chains"), page: "Chains", icon: Building2 },
//         { name: t("stores"), page: "Stores", icon: Building2 },
//         { name: t("safeCountAdmin"), page: "SafeCountAdmin", icon: Wallet },
//         { name: t("users"), page: "Users", icon: Users }, 
//         { name: "הגדרות מערכת", page: "SystemSettings", icon: Settings }
//       ];
//     }
    
//     if (isStoreManager) {
//       return [
//         ...baseItems,
//         { name: t("users"), page: "Users", icon: Users },
//       ];
//     }
    
//     if (isAreaManager) {
//       const allowedPages = ['Home', 'Returns', 'Destructions', 'ServiceRequests', 'Notifications', 'PromotionImplementation', 'ManageInventoryCounts'];
//       const areaItems = baseItems.filter(item => allowedPages.includes(item.page));
//       return [...areaItems, { name: t("users"), page: "Users", icon: Users }];
//     }

//     return baseItems; 
//   }; 

//   // const displayMenuItems = getMenuItemsForUser();

//   const MENU_ITEMS = getMenuItemsForUser(); // 👈 זה התיקון! היינו צריכים את הרשימה המלאה לפי תפקיד

//   const displayMenuItems = MENU_ITEMS.filter(item => {
//     // 1. בדיקת הרשאות מודולים
//     if (item.page === 'ServiceRequests') {
//        // גישה ישירה לאובייקט (אם קיים)
//        const access = currentUser?.modules_access?.service_requests;
       
//        // אם המשתמש לא סופר אדמין, והוגדר לו במפורש "none" -> הסתר
//        if (!currentUser?.isSuperAdmin && access === 'none') {
//            return false;
//        }
//     }

//     // 2. בדיקות תפקידים רגילות (הקוד הקיים)
//     if (item.roles && !item.roles.includes(roleKey)) return false;
//     if (item.excludeRoles && item.excludeRoles.includes(roleKey)) return false;
//     if (item.dataScope && item.dataScope !== dataScope) {
//         if (dataScope === 'GLOBAL') return true; 
//         return false;
//     }
//     return true;
//   });


//   const isMenuItemActive = (itemPage) => currentPageName === itemPage;
//   const mainCategories = []; 
//   const getSubCategories = () => []; 
//   // const unreadCount = 0; 

//   // רכיב לוגו לשימוש חוזר
//   const ChainLogoOrText = ({ className }) => {
//     if (userChain?.logo_url) {
//       return (
//         <div className={`flex items-center justify-center bg-white rounded-lg p-1 ${className}`}>
//            <img src={userChain.logo_url} alt={userChain.name} className="h-full w-auto object-contain" />
//         </div>
//       );
//     }
//     return (
//         <div className={`flex items-center justify-center bg-white/20 rounded-lg px-4 ${className}`}>
//             <span className="text-white font-bold text-lg">
//                 {isSystemAdmin ? t("systemAdmin") : isAreaManager ? t("areaManager") : "משתמש"}
//             </span>
//         </div>
//     );
//   };

//   // שליפת פריטי הסל עבור האייקון בהדר
//   const { data: cartItems = [] } = useQuery({
//     queryKey: ['cartItems', currentUser?.store_id],
//     queryFn: () => base44.entities.CartItem.list({ store_id: currentUser?.store_id }),
//     enabled: !!currentUser?.store_id && isStoreManager,
//   });

//   // חישוב כמות הפריטים הכוללת
//   const cartCount = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);

//   return (
//     <div dir="rtl" className="min-h-screen bg-gray-50">
      
//       {/* Header */}
//       <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
//         <div className="flex items-center justify-between px-4 py-3">
//           <div className="flex items-center gap-3">
//             <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
//               <SheetTrigger asChild>
//                 <Button variant="ghost" size="icon" className="lg:hidden">
//                   <Menu className="w-6 h-6" />
//                 </Button>
//               </SheetTrigger>
//               <SheetContent side="right" className="w-80 p-0">
//                 <div className="flex flex-col h-full">
//                   <div className={`p-6 flex flex-col items-end ${isAreaManager ? 'bg-gradient-to-l from-cyan-600 to-cyan-700' : 'bg-gradient-to-l from-emerald-600 to-emerald-700'}`}>
                    
//                     {/* --- השינוי כאן: הצגת לוגו בתפריט צד --- */}
//                     <ChainLogoOrText className="h-16 mb-2 w-full bg-white/90" />
//                     {/* -------------------------------------- */}

//                     <p className="text-emerald-100 text-sm">
//                       {currentUser?.fullName || "שלום אורח"}
//                     </p>
//                   </div>
//                   <nav className="flex-1 overflow-y-auto py-4">
//                     {displayMenuItems.map((item) => (
//                       <Link
//                         key={item.page}
//                         to={createPageUrl(item.page)}
//                         onClick={() => setIsMenuOpen(false)}
//                         className={`flex items-center justify-end gap-3 px-6 py-3 transition-colors ${
//                           isMenuItemActive(item.page)
//                             ? "bg-emerald-50 text-emerald-700 border-r-4 border-emerald-600"
//                             : "text-gray-600 hover:bg-gray-50"
//                         }`}
//                       >
//                         <span className="font-medium">{item.name}</span>
//                         <item.icon className="w-5 h-5" />
//                       </Link>
//                     ))}
//                   </nav>
//                   <div className="p-4 border-t">
//                     <Button
//                       variant="ghost"
//                       className="w-full flex items-center justify-end gap-3 px-2 text-red-600 hover:bg-red-50"
//                       onClick={logout}
//                     >
//                       <span>{t("logout")}</span>
//                       <LogOut className="w-5 h-5" />
//                     </Button>
//                   </div>
//                 </div>
//               </SheetContent>
//             </Sheet>

//             <Link to={createPageUrl("Home")} className="flex items-center gap-2">
//                 {/* --- השינוי כאן: הצגת לוגו ב-Header הראשי --- */}
//                 {userChain?.logo_url && !isSystemAdmin ? (
//                     <div className="h-10 flex items-center justify-center bg-white border border-gray-100 rounded-lg px-2 shadow-sm">
//                         <img 
//                             src={userChain.logo_url} 
//                             alt={userChain.name} 
//                             className="h-8 w-auto object-contain" 
//                         />
//                     </div>
//                 ) : (
//                     <div className="h-10 flex items-center justify-center bg-emerald-100 rounded-lg px-3 gap-2">
//                         <span className="text-emerald-700 font-bold text-sm">
//                             {isSystemAdmin ? t("systemAdmin") : "Reshet"}
//                         </span>
//                         <Home className="w-4 h-4 text-emerald-700" />
//                     </div>
//                 )}
//             </Link>
//           </div>

//           <div className="flex items-center gap-0">
//   {/* חיפוש */}
//   <Link to={createPageUrl("ProductSearch")}>
//     <Button variant="ghost" size="icon">
//       <Search className="w-5 h-5 text-gray-600" />
//     </Button>
//   </Link>

//   {/* קטגוריות (Sheet) */}
//   <Sheet open={categoriesOpen} onOpenChange={setCategoriesOpen}>
//     <SheetTrigger asChild>
//       <Button variant="ghost" size="icon">
//         <Grid3X3 className="w-5 h-5 text-gray-600" />
//       </Button>
//     </SheetTrigger>
//     <SheetContent side="right" className="w-80 overflow-y-auto [&>button]:left-4 [&>button]:right-auto">
//       <SheetHeader>
//         <SheetTitle className="text-right">{t("allCategories")}</SheetTitle>
//       </SheetHeader>

//       <div className="mt-6 space-y-3">
//         {mainCategories.map((mainCat) => {
//           const subCats = getSubCategories(mainCat.id);
//           return (
//             <div key={mainCat.id} className="border rounded-lg overflow-hidden">
//               <Link
//                 to={createPageUrl(`CategoryProducts?id=${mainCat.id}`)}
//                 onClick={() => setCategoriesOpen(false)}
//               >
//                 <div className="bg-emerald-600 hover:bg-emerald-700 transition-colors p-3 flex items-center justify-between cursor-pointer">
//                   <ChevronLeft className="w-4 h-4 text-white" />
//                   <span className="font-bold text-white">{mainCat.name}</span>
//                 </div>
//               </Link>

//               {subCats.length > 0 && (
//                 <div className="p-2 bg-gray-50 space-y-1">
//                   {subCats.map((subCat) => (
//                     <Link
//                       key={subCat.id}
//                       to={createPageUrl(`CategoryProducts?id=${subCat.id}`)}
//                       onClick={() => setCategoriesOpen(false)}
//                     >
//                       <div className="px-3 py-2 text-sm hover:bg-emerald-50 rounded transition-colors cursor-pointer text-right">
//                         {subCat.name}
//                       </div>
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </SheetContent>
//   </Sheet>

//   {/* התראות */}
//   <Link to={createPageUrl("Notifications")}>
//     <Button variant="ghost" size="icon" className="relative">
//       <Bell className="w-5 h-5 text-gray-600" />
//       {unreadCount > 0 && (
//         <Badge className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-red-500 text-white text-xs">
//           {unreadCount}
//         </Badge>
//       )}
//     </Button>
//   </Link>

//   {isStoreManager && (
//     <Link to={createPageUrl("Cart")}>
//       <Button variant="ghost" size="icon" className="relative">
//         <ShoppingCart className="w-5 h-5 text-gray-600" />
//         {cartCount > 0 && (
//           <Badge className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-emerald-600 text-white text-xs">
//             {cartCount}
//           </Badge>
//         )}
//       </Button>
//     </Link>
//   )}

//   {/* התנתקות */}
//   <Button variant="ghost" size="icon" onClick={logout} title={t("logout")}>
//     <LogOut className="w-5 h-5 text-red-500" />
//   </Button>
// </div>

//         </div>
//       </header>

//       {/* Desktop Sidebar */}
//       <div className="flex">
//         <aside className="hidden lg:flex flex-col w-64 h-[calc(100vh-65px)] bg-white border-r border-gray-100 sticky top-[65px]">
//           <nav className="flex-1 py-4 overflow-y-auto">
//             {displayMenuItems.map((item) => (
//               <Link
//                 key={item.page}
//                 to={createPageUrl(item.page)}
//                 className={`flex items-center justify-start gap-3 px-6 py-3 transition-colors ${
//                   isMenuItemActive(item.page)
//                     ? "bg-emerald-50 text-emerald-700 border-r-4 border-emerald-600"
//                     : "text-gray-600 hover:bg-gray-50"
//                 }`}
//               >
//                 <item.icon className="w-5 h-5" />
//                 <span className="font-medium">{item.name}</span>
//               </Link>
//             ))}
//           </nav>
//           <div className="p-4 border-t bg-white">
//             <Button
//               variant="ghost"
//               className="w-full flex items-center justify-start gap-3 px-2 text-red-600 hover:bg-red-50"
//               onClick={logout}
//             >
//               <LogOut className="w-5 h-5" />
//               <span>{t("logout")}</span>
//             </Button>
//           </div>
//         </aside>

//         <main className="flex-1 min-h-[calc(100vh-65px)] bg-gradient-to-br from-emerald-50 via-teal-50 to-blue-50">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// }




import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
// import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

import { createPageUrl } from "@/utils";
import { handleMenuNavigation } from "@/utils/scrollContainer";
import { base44 } from "@/api/base44Client"; 
import { useAuth } from "@/auth/AuthContext"; 
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { normalizeStoreId } from "@/lib/offlineCart";
import {
  shouldPreferLocalData,
  notificationPollIntervalMs,
  branchQueryOptions,
} from "@/lib/connectionQuality";
import { runSmartCartSync } from "@/lib/cartSync";
import { useCartItemsQuery } from "@/hooks/useCartItemsQuery";
import { useLocalStore } from "@/contexts/LocalStoreContext";
import { useAreaManagerSession } from "@/contexts/AreaManagerSessionContext";
import { getTranslation } from "@/components/utils/translations";
import { BUILD_ID, formatBuildIdLabel } from "@/lib/appUpdate";
import { motion } from "framer-motion";

import {
  Home, ShoppingCart, Bell, Menu, X, Package, Truck, Tag, Star,
  AlertTriangle, Sparkles, Wrench, ClipboardList, Trash2, RotateCcw,
  Building2, Grid3X3, ChevronLeft, LogOut, FileText, Users, Wallet, Settings,
  Filter, LayoutGrid, ArrowDownAZ, Flame, RefreshCw, BarChart3,
  Activity, FileScan, Share2, Layers, Phone, Trophy,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { useCategoryFilter } from "@/contexts/CategoryFilterContext";
import { useProductLabelSettings } from "@/contexts/ProductLabelSettingsContext";
import { MatzahIcon } from "@/components/icons/MatzahIcon";
import HeaderQuickProductSearch from "@/components/common/HeaderQuickProductSearch";
import { BAKED_AFTER_PASSOVER_LABEL } from "@/lib/utils";
import { hardRefreshApp } from "@/lib/hardRefresh";
import PushNotificationPrompt from "@/components/notifications/PushNotificationPrompt";
import CustomMessagePopup from "@/components/notifications/CustomMessagePopup";
import SystemUpdateStories from "@/components/updates/SystemUpdateStories";
import SupportContactPopup from "@/components/common/SupportContactPopup";
import PwaInstallMenuItem from "@/components/pwa/PwaInstallMenuItem";
import { useDeviceTier } from "@/hooks/useDeviceTier";
import { HeaderQuickSearchOverlayProvider } from "@/contexts/HeaderQuickSearchOverlayContext";
// import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

export default function Layout({ children, currentPageName }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();
  const { user: currentUser, logout } = useAuth();
  const cartAccess = currentUser?.isSuperAdmin 
    ? 'edit' 
    : (currentUser?.modules_access?.cart || 'none');

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [isCategoryFilterOpen, setIsCategoryFilterOpen] = useState(false);
  const [isHardRefreshing, setIsHardRefreshing] = useState(false);
  const [headerSearchExpanded, setHeaderSearchExpanded] = useState(false);
  const [dismissedPopupIds, setDismissedPopupIds] = useState(() => new Set());
  const [supportContactOpen, setSupportContactOpen] = useState(false);
  const categoryFilter = useCategoryFilter();
  const { isConstrained } = useDeviceTier();
  const { showKosherPassoverLabel, showBakedAfterPassoverLabel, isLoading: uiLabelsLoading } = useProductLabelSettings();

  const { data: uiLabels, refetch: refetchUiLabels } = useQuery({
    queryKey: ["settings", "ui-labels"],
    queryFn: () => base44.entities.SystemSetting.getUiLabels(),
    staleTime: 60 * 1000,
    enabled: !!currentUser,
  });
  const supportPhone = uiLabels?.supportContact?.phone || "";
  const supportWhatsapp = uiLabels?.supportContact?.whatsapp || supportPhone;

  const openSupportContact = useCallback(() => {
    setSupportContactOpen(true);
    refetchUiLabels();
  }, [refetchUiLabels]);

  useEffect(() => {
    setHeaderSearchExpanded(false);
  }, [location.pathname]);
  useEffect(() => {
    if (uiLabelsLoading) return;
    if (!showKosherPassoverLabel) categoryFilter.setShowPassover(false);
  }, [uiLabelsLoading, showKosherPassoverLabel, categoryFilter.setShowPassover]);
  useEffect(() => {
    if (uiLabelsLoading) return;
    if (!showBakedAfterPassoverLabel) categoryFilter.setShowBakedAfterPassover(false);
  }, [uiLabelsLoading, showBakedAfterPassoverLabel, categoryFilter.setShowBakedAfterPassover]);

  const isCategoriesOrCategoryProducts =
    location.pathname === "/Categories" || location.pathname === "/CategoryProducts";
  const isCategoryProductsPage = location.pathname === "/CategoryProducts";

  const [language, setLanguage] = useState("he");

  const t = (key) => getTranslation(language, key);

  const roleKey = currentUser?.role?.key || currentUser?.role;
  const isMerlogManager = roleKey === 'MERLOG_MANAGER';
  const isPromotionsManager = roleKey === 'PROMOTIONS_ADMIN';
  const isSuperAdminUser = currentUser?.isSuperAdmin === true || roleKey === 'SUPER_ADMIN' || roleKey === 'admin';
  const isStrictSuperAdmin = currentUser?.isSuperAdmin === true || roleKey === "SUPER_ADMIN";
  const isSystemAdmin = isSuperAdminUser || roleKey === 'SYSTEM_ADMIN' || currentUser?.custom_role === 'system_admin' || isPromotionsManager || isMerlogManager;
  const canManageOrderRecommendations =
    isSuperAdminUser || roleKey === "SYSTEM_ADMIN" || currentUser?.custom_role === "system_admin";
  const isStoreManager =
    roleKey === "SUPER_MANAGER" ||
    roleKey === "STORE_MANAGER" ||
    currentUser?.custom_role === "store_manager";
  const isAreaManager =
    roleKey === "AREA_MANAGER" ||
    currentUser?.custom_role === "area_manager" ||
    currentUser?.custom_role === "AREA_MANAGER";
  const { isActingAsStore, actingStoreId, actingStoreName, enterStore, exitStore } = useAreaManagerSession();
  const activeStoreIdFromUrl = new URLSearchParams(location.search).get("storeId")?.trim() || "";
  const activeStoreNameFromUrl = new URLSearchParams(location.search).get("storeName")?.trim() || "";
  const isAreaManagerStorePicker = location.pathname === "/AreaManagerStores";
  /** מסך בית של מנהל אזור (בחירת סניפים / בלי כניסה לסניף) — בלי תפריט/סל/התראות של סניף */
  const isAreaManagerHub =
    isAreaManager && (isAreaManagerStorePicker || !isActingAsStore);
  const isBranchStoreManager = isStoreManager || isActingAsStore || (isAreaManager && !!activeStoreIdFromUrl);
  const isBranchSession = isBranchStoreManager;

  useEffect(() => {
    if (isBranchSession) categoryFilter.setShowReturnedToStock(false);
  }, [isBranchSession, categoryFilter.setShowReturnedToStock]);

  const withActiveStoreInUrl = useCallback(
    (url) => {
      const activeId = activeStoreIdFromUrl || actingStoreId;
      const activeName = activeStoreNameFromUrl || actingStoreName;
      if (!isAreaManager || !activeId) return url;
      const [path, rawQuery = ""] = String(url).split("?");
      const params = new URLSearchParams(rawQuery);
      params.set("storeId", activeId);
      if (activeName) params.set("storeName", activeName);
      const query = params.toString();
      return query ? `${path}?${query}` : path;
    },
    [activeStoreIdFromUrl, activeStoreNameFromUrl, actingStoreId, actingStoreName, isAreaManager]
  );

  useEffect(() => {
    if (!isAreaManager || !activeStoreIdFromUrl) return;
    if (isAreaManagerStorePicker) return;
    if (String(actingStoreId || "") === String(activeStoreIdFromUrl)) return;

    enterStore({ _id: activeStoreIdFromUrl, name: activeStoreNameFromUrl });
    base44.areaManager.getActingStore(activeStoreIdFromUrl)
      .then((result) => {
        if (result?.store?._id) enterStore(result.store);
      })
      .catch(() => {
        exitStore();
        navigate("/AreaManagerStores", { replace: true });
      });
  }, [activeStoreIdFromUrl, activeStoreNameFromUrl, actingStoreId, enterStore, exitStore, isAreaManager, isAreaManagerStorePicker, navigate]);

  useEffect(() => {
    if (!isAreaManager || !isActingAsStore || !actingStoreId) return;
    if (isAreaManagerStorePicker) return;
    if (activeStoreIdFromUrl) return;
    if (String(activeStoreIdFromUrl) === String(actingStoreId)) return;
    navigate(withActiveStoreInUrl(`${location.pathname}${location.search}`), { replace: true });
  }, [
    activeStoreIdFromUrl,
    actingStoreId,
    isAreaManagerStorePicker,
    isActingAsStore,
    isAreaManager,
    location.pathname,
    location.search,
    navigate,
    withActiveStoreInUrl,
  ]);

  const areaManagerAllowedPaths =
    location.pathname === "/AreaManagerStores" ||
    location.pathname === "/AreaManagerOrders" ||
    location.pathname === "/AreaManagerSafeCounts" ||
    location.pathname === "/SafeCount" ||
    location.pathname === "/Orders" ||
    location.pathname === "/SalesAnalytics" ||
    location.pathname === "/SalesPeriodAnalysis" ||
    location.pathname === "/Returns" ||
    location.pathname === "/ReturnDetails" ||
    location.pathname.startsWith("/OrderDetails");

  const { data: notifications = [] } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      try {
        return await base44.entities.Notification.list();
      } catch (e) {
        return [];
      }
    },
    enabled: !!currentUser,
    ...branchQueryOptions({ staleTimeFast: 15_000, staleTimeSlow: 90_000 }),
    // ב־3G: כל ~90 שנ׳ במקום כל 8 שנ׳ (אחרת הרשת נחנקת לגמרי)
    refetchInterval: notificationPollIntervalMs(),
    refetchOnReconnect: true,
  });

  // חישוב מספר ההודעות שלא נקראו
  const unreadCount = notifications.filter(n => !n.is_read).length;

  const popupNotification = useMemo(() => {
    const uid = String(currentUser?._id || currentUser?.id || "");
    return (
      notifications.find((n) => {
        if (!n.show_as_popup || n.is_read) return false;
        const nid = String(n.id || n._id);
        if (dismissedPopupIds.has(nid)) return false;
        // פופאפ ממוקד למשתמש — רק לנמען (מונע מאדמין לראות פופאפים של סניפים)
        const ownerId = n.user_id ? String(n.user_id?._id || n.user_id) : "";
        if (ownerId && uid && ownerId !== uid) return false;
        // במערכת ניהול — לא מציגים פופאפים בלי נמען אישי
        if (isSystemAdmin && !ownerId) return false;
        return true;
      }) || null
    );
  }, [notifications, dismissedPopupIds, currentUser, isSystemAdmin]);

  const handleCloseMessagePopup = useCallback(async () => {
    if (!popupNotification) return;
    const needsAck = !!(popupNotification.require_ack || String(popupNotification.ack_question || "").trim());
    if (needsAck) return;
    const id = String(popupNotification.id || popupNotification._id);
    // מסירים מיד מהמסך — גם אם העדכון בשרת נכשל
    setDismissedPopupIds((prev) => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
    try {
      await base44.entities.Notification.update(id, { is_read: true });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    } catch (e) {
      // נשאר dismissed מקומית כדי שלא יופיע שוב באותה סשן
    }
  }, [popupNotification, queryClient]);

  const handleAcknowledgePopup = useCallback(async (answer = "") => {
    if (!popupNotification) return;
    const id = String(popupNotification.id || popupNotification._id);
    await base44.entities.Notification.acknowledge(id, { answer });
    setDismissedPopupIds((prev) => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
    queryClient.invalidateQueries({ queryKey: ["notifications"] });
    queryClient.invalidateQueries({ queryKey: ["notification-campaigns"] });
  }, [popupNotification, queryClient]);
  const { storeId: localStoreId, localData: prefetched } = useLocalStore();
  const preferLocalNet = shouldPreferLocalData();
  const layoutStoreId = isActingAsStore
    ? actingStoreId
    : isAreaManager
      ? null
      : currentUser?.store_id && typeof currentUser.store_id === "object"
        ? currentUser.store_id._id
        : currentUser?.store_id || null;
  const layoutPrefetchedStoreId = prefetched?.store?._id ?? prefetched?.store?.id;
  const prefetchedStore =
    prefetched?.store &&
    layoutStoreId &&
    String(layoutPrefetchedStoreId || "") === String(layoutStoreId)
      ? prefetched.store
      : null;
  const prefetchedChain =
    prefetched?.chain &&
    layoutStoreId &&
    String(layoutPrefetchedStoreId || "") === String(layoutStoreId)
      ? prefetched.chain
      : null;

  const { data: userStoreFromApi } = useQuery({
    queryKey: ["myStore", actingStoreId, currentUser?.store_id],
    queryFn: async () => {
      if (!layoutStoreId) return null;
      try {
        return await base44.entities.Store.get(layoutStoreId);
      } catch (e) {
        return null;
      }
    },
    enabled:
      !!layoutStoreId &&
      !isSystemAdmin &&
      !(preferLocalNet && prefetchedStore),
    ...branchQueryOptions({ staleTimeFast: 5 * 60 * 1000, staleTimeSlow: 30 * 60 * 1000 }),
  });
  const userStore = prefetchedStore || userStoreFromApi;

  const { data: userChainFromApi } = useQuery({
    queryKey: ["myChain", userStore?.chain_id?._id || userStore?.chain_id],
    queryFn: async () => {
      const chainId =
        userStore?.chain_id && typeof userStore.chain_id === "object"
          ? userStore.chain_id._id
          : userStore?.chain_id || null;
      if (!chainId) return null;
      try {
        const chains = await base44.entities.Chain.list();
        return chains.find((c) => (c.id || c._id) === chainId) || null;
      } catch (e) {
        return null;
      }
    },
    // ברשת חלשה / יש רשת בprefetch — לא מורידים את כל הרשתות רק בשביל לוגו
    enabled: !!userStore && !prefetchedChain && !preferLocalNet,
    ...branchQueryOptions({ staleTimeFast: 30 * 60 * 1000, staleTimeSlow: 60 * 60 * 1000 }),
  });
  const userChain = prefetchedChain || userChainFromApi;

  const { data: actingStoreBranchManager } = useQuery({
    queryKey: ["actingStoreBranchManager", actingStoreId],
    queryFn: async () => {
      const users = await base44.entities.User.list();
      const sid = String(actingStoreId);
      return (
        users.find((u) => {
          const uStore = String(u.store_id?._id ?? u.store_id ?? "");
          if (uStore !== sid) return false;
          const rk = u.role?.key || u.role;
          return (
            rk === "SUPER_MANAGER" ||
            rk === "STORE_MANAGER" ||
            u.custom_role === "store_manager"
          );
        }) ?? null
      );
    },
    enabled: isActingAsStore && !!actingStoreId && !preferLocalNet,
    ...branchQueryOptions({ staleTimeFast: 5 * 60 * 1000, staleTimeSlow: 30 * 60 * 1000 }),
  });

  const storeId =
    activeStoreIdFromUrl ||
    localStoreId ||
    actingStoreId ||
    (isAreaManager ? null : (currentUser?.store_id?._id || currentUser?.store_id));
  const branchId = String(currentUser?.branch_id?._id || currentUser?.branch_id || "");
  const prefetchedStoreId = layoutPrefetchedStoreId;
  const isPrefetchedForActiveStore = !!storeId && String(prefetchedStoreId || "") === String(storeId);
  const actingStoreDisplayName = isPrefetchedForActiveStore ? (prefetched?.store?.name || actingStoreName) : actingStoreName;
  const effectiveCartAccess = isActingAsStore ? "edit" : cartAccess;

  const isBranchCartUser =
    isActingAsStore ||
    !!currentUser?.isSuperAdmin ||
    ["SUPER_MANAGER", "store_manager", "SUPER_USER"].includes(roleKey);

  const { data: cartItems = [] } = useCartItemsQuery(storeId, {
    enabled: !!storeId && isBranchSession,
  });

  useEffect(() => {
    const sid = normalizeStoreId(storeId);
    if (!sid || !isBranchSession) return;
    const sync = () => {
      // רשת חלשה: רק מעלה dirty (לא מושך סל מלא שחונק ניווט)
      // רשת טובה: סנכרון מלא
      runSmartCartSync(sid, queryClient, branchId);
    };
    if (typeof navigator !== "undefined" && navigator.onLine) {
      sync();
    }
    window.addEventListener("online", sync);
    return () => window.removeEventListener("online", sync);
  }, [storeId, branchId, isBranchSession, queryClient]);

  useEffect(() => {
    if (!storeId) return;
    const preloadBranchChunks = () => {
      import("./Categories");
      import("./StoreProducts.jsx");
      import("./Companies");
      import("./CategoryProducts.jsx");
      import("./CompanyProducts");
      import("./Cart");
      import("./ProductDetails");
      import("./Promotions");
      import("./Orders");
      import("./SafeCount");
    };
    const scheduleIdle =
      typeof window !== "undefined" && "requestIdleCallback" in window
        ? window.requestIdleCallback
        : (cb) => setTimeout(cb, 1200);
    const cancelIdle =
      typeof window !== "undefined" && "cancelIdleCallback" in window
        ? window.cancelIdleCallback
        : clearTimeout;
    const taskId = scheduleIdle(preloadBranchChunks, { timeout: 2500 });
    return () => cancelIdle(taskId);
  }, [storeId]);

  const showHeaderSearch =
    !!storeId &&
    !isSystemAdmin &&
    isBranchCartUser &&
    effectiveCartAccess !== "none" &&
    (prefetched?.products?.length ?? 0) > 0;

  const getMenuItems = () => {
    return [
      { name: t("home"), page: "Home", icon: Home },
      { name: t("storeProducts"), page: "StoreProducts", icon: Package },
      { name: t("categories"), page: "Categories", icon: Grid3X3 },
      { name: t("companies"), page: "Companies", icon: Building2 },
      { name: t("suppliers"), page: "Suppliers", icon: Truck },
      { name: t("promotions"), page: "Promotions", icon: Tag },
      { name: t("brochures"), page: "Brochures", icon: FileText },
      { name: t("promotionImplementation"), page: "PromotionImplementation", icon: Tag },
      { name: t("mustOrder"), page: "MustOrder", icon: AlertTriangle },
      { name: t("newProducts"), page: "NewProducts", icon: Sparkles },
      { name: t("slowMovingProducts"), page: "SlowMovingProducts", icon: ClipboardList },
      { name: t("orders"), page: "Orders", icon: Package },
      { name: t("serviceRequests"), page: "ServiceRequests", icon: Wrench },
      { name: t("inventoryCount"), page: "InventoryCount", icon: ClipboardList },
      { name: t("safeCount"), page: "SafeCount", icon: Wallet },
      { name: t("notifications"), page: "Notifications", icon: Bell },
      { name: t("destructions"), page: "Destructions", icon: Trash2 },
      { name: t("returns"), page: "Returns", icon: RotateCcw },
      { name: "משימות הנהלה", page: "StoreManagementTasks", icon: ClipboardList },
      
    ];
  };

  const getMenuItemsForUser = () => {
    let baseItems = [...getMenuItems()];

    if (isSystemAdmin) {
      baseItems = baseItems.filter(item => 
        !["StoreProducts", "NewProducts", "InventoryCount", "SafeCount"].includes(item.page)
      );
      
      const items = [...baseItems];
      items.splice(1, 0, { name: t("products"), page: "Products", icon: Package });

      const promotionImplIndex = items.findIndex(item => item.page === "PromotionImplementation");
      if (promotionImplIndex !== -1) {
        items.splice(promotionImplIndex + 1, 0, { name: t("manageInventoryCounts"), page: "ManageInventoryCounts", icon: ClipboardList });
      }

      if (canManageOrderRecommendations) {
        const recIndex = items.findIndex((item) => item.page === "MustOrder");
        if (recIndex !== -1) {
          items.splice(recIndex, 0, { name: t("recommendations"), page: "Recommendations", icon: Star });
        }
      }

      // רשימת הזמנות מתחת למוצרים
      const ordersIdx = items.findIndex((item) => item.page === "Orders");
      if (ordersIdx !== -1) {
        const [ordersItem] = items.splice(ordersIdx, 1);
        const productsIdx = items.findIndex((item) => item.page === "Products");
        if (productsIdx !== -1) {
          items.splice(productsIdx + 1, 0, ordersItem);
        } else {
          items.splice(ordersIdx, 0, ordersItem);
        }
      }

      // מלאי סניפים מעל קריאות שירות
      const storeComaxItem = { name: "מלאי סניפים", page: "StoreComaxCatalog", icon: Layers };
      const serviceIdx = items.findIndex((item) => item.page === "ServiceRequests");
      if (serviceIdx !== -1) {
        items.splice(serviceIdx, 0, storeComaxItem);
      } else {
        items.push(storeComaxItem);
      }

      const adminItems = [
        ...items,
        { name: "מרכז מכירות", page: "SalesAnalytics", icon: BarChart3 },
        { name: "ניתוח תקופות", page: "SalesPeriodAnalysis", icon: BarChart3 },
        { name: t("chains"), page: "Chains", icon: Building2 },
        { name: t("stores"), page: "Stores", icon: Building2 },
        { name: "משימות הנהלה", page: "ManagementTasks", icon: ClipboardList },
        { name: "עדכוני מערכת", page: "SystemUpdates", icon: Sparkles },
        { name: "חלוקות", page: "Distributions", icon: Share2 },
        { name: t("safeCountAdmin"), page: "SafeCountAdmin", icon: Wallet },
        { name: t("users"), page: "Users", icon: Users }, 
        { name: "הגדרות מערכת", page: "SystemSettings", icon: Settings }
      ];
      if (isStrictSuperAdmin) {
        adminItems.splice(adminItems.length - 1, 0, { name: "קשת גיבורים", page: "KeshetHeroes", icon: Trophy });
        adminItems.splice(adminItems.length - 1, 0, { name: "בקרת מערכת", page: "SystemHealth", icon: Activity });
        adminItems.splice(adminItems.length - 1, 0, { name: "ניהול סריקות", page: "InvoiceScanAdmin", icon: FileScan });
      }
      return adminItems;
    }
    
    if (isBranchStoreManager) {
      return [
        ...baseItems,
        { name: t("users"), page: "Users", icon: Users },
      ];
    }

    if (isAreaManager) {
      return [
        { name: "הסניפים שלי", page: "AreaManagerStores", icon: Building2 },
        { name: "רשימת הזמנות", page: "AreaManagerOrders", icon: Package },
        { name: "ספירת כספות", page: "AreaManagerSafeCounts", icon: Wallet },
        { name: "מרכז מכירות", page: "SalesAnalytics", icon: BarChart3 },
        { name: "ניתוח תקופות", page: "SalesPeriodAnalysis", icon: BarChart3 },
      ];
    }

    if (roleKey === 'MERLOG_MANAGER') {
      return [
        { name: t("home"), page: "Home", icon: Home },
        { name: t("suppliers"), page: "Suppliers", icon: Truck },
        { name: t("orders"), page: "Orders", icon: Package },
        { name: t("stores"), page: "Stores", icon: Building2 }
      ];
    }

    if (roleKey === 'HR_MANAGER') {
      return [
        { name: t("notifications"), page: "Notifications", icon: Bell },
        { name: "משתמשים", page: "Users", icon: Users },
      ];
    }

    return baseItems;
  }; 

  // const displayMenuItems = getMenuItemsForUser();

  const MENU_ITEMS = getMenuItemsForUser(); // 👈 זה התיקון! היינו צריכים את הרשימה המלאה לפי תפקיד

// Layout.jsx
const moduleMapping = {
  // דף הבית
  "Home": "home",

  // מוצרים
  "Products": "products_admin",
  "StoreComaxCatalog": "products_admin",
  "StoreProducts": "store_products",
  "ProductSearch": "product_search",
  "NewProducts": "new_products",
  
  // מלאי וספירות (הכפתור ששאלת עליו)
  "InventoryCount": "inventory_count",         // ספירה בסניף
  "ManageInventoryCounts": "inventory_manage", // ניהול ספירות (אדמין) 👈
  "SafeCount": "safe_count",
  "SafeCountAdmin": "safe_count",

  // ללא תנועה (הכפתור ששאלת עליו)
  "SlowMovingProducts": "slow_moving",         // בסניף 👈
  "AllSlowMovingProducts": "all_slow_moving",  // רשתי 👈

  // הזמנות ומבצעים
  "Recommendations": "recommendations",
  "MustOrder": "must_order",
  "Promotions": "promotions",
  "Brochures": "brochures",
  "PromotionImplementation": "promotion_impl",
  "Orders": "orders",

  // ניהול רשת
  "Chains": "chains",
  "Stores": "stores",
  "Suppliers": "suppliers",
  "Companies": "companies",
  "Categories": "categories",

  // מערכת
  "Notifications": "notifications",
  "ServiceRequests": "service_requests",
  "Destructions": "destructions",
  "Returns": "returns",
  "StoreManagementTasks": "tasks",
  "ManagementTasks": "tasks",
  "Distributions": "distributions",
  "Users": "users",
  "SystemSettings": "system_settings",
  "SalesAnalytics": "sales_analytics",
  "SalesPeriodAnalysis": "sales_analytics",
  "Cart": "cart"
};
  // const displayMenuItems = MENU_ITEMS.filter(item => {
  //   // א. סופר אדמין רואה הכל
  //   if (currentUser?.isSuperAdmin) return true;

  //   if (roleKey === 'PROMOTIONS_ADMIN') {
  //     // מנהל מבצעים רואה רק את דף הבית ואת דף המבצעים
  //     return [ 'Promotions'].includes(item.page);
  // }    

  //   // ב. בדיקה אם המודול חסום (none)
  //   const moduleKey = moduleMapping[item.page];
  //   if (moduleKey) {
  //     const access = currentUser?.modules_access?.[moduleKey];
  //     if (access === 'none') return false; 
  //   }

  //   // ג. כאן נכנסת הלוגיקה המקורית שלך - אנחנו לא נוגעים בה!
  //   if (item.adminOnly) return isSuperAdmin;
  //   if (item.areaManagerOnly) return isAreaManager;
    
  //   return true;
  // });

 
  const menuModulesAccess = useMemo(() => {
    if (isActingAsStore) {
      const base = actingStoreBranchManager?.modules_access || currentUser?.modules_access || {};
      if (isAreaManager) {
        const returnsAccess = currentUser?.modules_access?.returns || "none";
        return { ...base, returns: returnsAccess };
      }
      return base;
    }
    return currentUser?.modules_access;
  }, [isActingAsStore, isAreaManager, actingStoreBranchManager?.modules_access, currentUser?.modules_access]);

  const storeFacingPages = useMemo(() => {
    const pages = new Set(getMenuItems().map((item) => item.page));
    pages.add("Users");
    return pages;
  }, [language]);

  const displayMenuItems = MENU_ITEMS.filter(item => {
    // 1. סופר אדמין תמיד רואה הכל
    if (currentUser?.isSuperAdmin) return true;

    // מנהל אזור מחובר לסניף – תפריט לפי הרשאות מנהל הסניף בפועל
    if (isActingAsStore) {
      if (actingStoreBranchManager === null) {
        return storeFacingPages.has(item.page);
      }
      if (!actingStoreBranchManager) return false;
    }
  
    // 2. בדיקת הרשאות מודולים מה-DB
    const moduleKey = moduleMapping[item.page];
    if (moduleKey) {
      if (moduleKey === "returns") {
        if (isAreaManager && !isActingAsStore && !activeStoreIdFromUrl) return false;
        if (isAreaManager) {
          const returnsAccess = currentUser?.modules_access?.returns;
          return returnsAccess === "view" || returnsAccess === "edit";
        }
      }
      const access = menuModulesAccess?.[moduleKey];
      // מציגים רק אם הגישה היא 'view' או 'edit'. אם 'none' - מסתירים
      return access === 'view' || access === 'edit';
    }
  
    // 3. דפים שאין להם הרשאה ספציפית (כמו דף הבית) - יוצגו לכולם
    return true;
  });
 
  const isMenuItemActive = (itemPage) => currentPageName === itemPage;
  const mainCategories = []; 
  const getSubCategories = () => []; 
  // const unreadCount = 0; 

  // רכיב לוגו לשימוש חוזר – לוגו מהמקומי (prefetch) או מהשרת
  const chainForLogo = prefetched?.chain || userChain;
  const ChainLogoOrText = ({ className }) => {
    if (!currentUser) return <div className={`animate-pulse bg-gray-200 rounded-lg ${className}`} />;
    const isActualStoreManager = (!!currentUser.store_id || isActingAsStore) && !isSystemAdmin;
    const logoUrl = chainForLogo?.logo_data_url || chainForLogo?.logo_url;
    if (logoUrl && isActualStoreManager) {
      return (
        <div className={`flex items-center justify-center bg-white rounded-lg p-1 ${className}`}>
          <img src={logoUrl} alt={chainForLogo?.name || "רשת"} className="h-full w-auto object-contain" />
        </div>
      );
    }
    
    // 3. מנהלי מערכת/מרלוג: מציגים מיד את השם מה-Role
    return (
      <div className={`flex items-center justify-center bg-emerald-100 rounded-lg px-3 ${className}`}>
          <span className="text-emerald-700 font-bold text-sm text-center">
              {currentUser?.role?.name || "Reshet"}
          </span>
      </div>
    );
  };
  const cartCount = Array.isArray(cartItems) ? cartItems.length : 0;

  const handleHardRefresh = async () => {
    if (isHardRefreshing) return;
    setIsHardRefreshing(true);
    try {
      await hardRefreshApp({
        storeId: isBranchSession && storeId ? storeId : null,
        queryClient,
        navigate,
        returnPath: `${location.pathname}${location.search}`,
      });
    } catch {
      setIsHardRefreshing(false);
    } finally {
      // מסירים סיבוב ברגע שהמעבר למסך הרענון / reload התחיל — שם יש progress משלו
      setIsHardRefreshing(false);
    }
  };

  useEffect(() => {
    setIsHardRefreshing(false);
  }, [location.pathname]);

  // גלילה רק ב-main — חוסם "שחרור" גלילה ל-html/body אחרי סוף התוכן
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("app-scroll-lock");

    const keyboardOpen = () => {
      const vv = window.visualViewport;
      if (!vv) return false;
      return vv.offsetTop > 0 || window.innerHeight - vv.height > 80;
    };

    const resetWindowScroll = () => {
      // במקלדת פתוחה (מסופון/אנדרואיד) אל תילחם ב־scroll של המערכת
      if (keyboardOpen()) return;
      if (window.scrollY !== 0) window.scrollTo(0, 0);
    };
    window.addEventListener("scroll", resetWindowScroll, { passive: true });

    const main = document.querySelector("main");
    const blockScrollChain = (e) => {
      if (!main) return;
      const { scrollTop, scrollHeight, clientHeight } = main;
      const atTop = scrollTop <= 0;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 2;
      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    };
    main?.addEventListener("wheel", blockScrollChain, { passive: false });

    const onFocusIn = (e) => {
      const el = e.target;
      if (!(el instanceof HTMLElement)) return;
      if (!el.matches("input, textarea, select, [contenteditable='true']")) return;
      // שדה כמות בכרטיס מוצר — אל תמרכז, זה קופץ את רשימת המוצרים
      if (el.dataset.qtyInput === "true" || el.closest("[data-qty-input]")) return;
      window.setTimeout(() => {
        el.scrollIntoView({ block: "center", inline: "nearest" });
      }, 280);
    };
    document.addEventListener("focusin", onFocusIn);

    return () => {
      html.classList.remove("app-scroll-lock");
      window.removeEventListener("scroll", resetWindowScroll);
      main?.removeEventListener("wheel", blockScrollChain);
      document.removeEventListener("focusin", onFocusIn);
    };
  }, [location.pathname]);

  if (isAreaManager && !isActingAsStore && !areaManagerAllowedPaths) {
    return <Navigate to="/AreaManagerStores" replace />;
  }

  return (
    <HeaderQuickSearchOverlayProvider active={headerSearchExpanded}>
    <div dir="rtl" className="flex h-[var(--app-vh,100dvh)] flex-col overflow-hidden bg-gray-50">
      
      {/* Header — מוסתר במסך הבית של מנהל אזור (לפני כניסה לסניף) */}
      {!isAreaManagerHub && (
      <header className="sticky top-0 z-50 shrink-0 bg-white border-b border-gray-100 shadow-sm">
        <div className={`flex items-center w-full gap-2 ${isConstrained ? "px-2 py-1.5" : "px-4 py-3"}`}>
          <div className="flex items-center gap-3 shrink-0">
            <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="lg:hidden min-h-11 min-w-11">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80 p-0">
                <div className="flex flex-col h-full">
                  <div className={`p-6 flex flex-col items-end ${isAreaManager && !isActingAsStore ? 'bg-gradient-to-l from-cyan-600 to-cyan-700' : 'bg-gradient-to-l from-emerald-600 to-emerald-700'}`}>
                    
                    {/* --- השינוי כאן: הצגת לוגו בתפריט צד --- */}
                    <ChainLogoOrText className="h-16 mb-2 w-full bg-white/90" />
                    {/* -------------------------------------- */}

                    <p className="text-emerald-100 text-sm">
                      {currentUser?.fullName || "שלום אורח"}
                    </p>
                  </div>
                  <nav className="flex-1 overflow-y-auto py-4">
                    {displayMenuItems.map((item) => {
                      const url = createPageUrl(item.page);
                      const toUrl = withActiveStoreInUrl(url);
                      const isCurrentPage = location.pathname === url || location.pathname === url + "/";
                      return (
                        <Link
                          key={item.page}
                          to={toUrl}
                          onClick={() => {
                            handleMenuNavigation(item.page, isCurrentPage);
                            setIsMenuOpen(false);
                          }}
                          className={`flex items-center justify-end gap-3 px-6 py-3 transition-colors ${
                            isMenuItemActive(item.page)
                              ? "bg-emerald-50 text-emerald-700 border-r-4 border-emerald-600"
                              : "text-gray-600 hover:bg-gray-50"
                          }`}
                        >
                          <span className="font-medium">{item.name}</span>
                          <item.icon className="w-5 h-5" />
                        </Link>
                      );
                    })}
                  </nav>
                  <div className="flex flex-col gap-1 border-t p-4">
                    <Button
                      type="button"
                      variant="ghost"
                      className="w-full flex items-center justify-end gap-3 px-2 text-emerald-700 hover:bg-emerald-50"
                      onClick={() => {
                        setIsMenuOpen(false);
                        openSupportContact();
                      }}
                    >
                      <span className="font-medium" dir="rtl">
                        נתקלת בבעיה{"\u200F"}?
                      </span>
                      <Phone className="w-5 h-5 shrink-0" />
                    </Button>
                    {isActingAsStore && !isAreaManagerStorePicker ? (
                      <Button
                        variant="outline"
                        className="w-full flex items-center justify-end gap-3 px-2 border-cyan-200 text-cyan-800 hover:bg-cyan-50"
                        onClick={() => {
                          exitStore();
                          setIsMenuOpen(false);
                          navigate("/AreaManagerStores");
                        }}
                      >
                        <span>התנתקות מהסניף</span>
                      </Button>
                    ) : null}
                    <PwaInstallMenuItem
                      layout="mobile"
                      onNavigate={() => setIsMenuOpen(false)}
                    />
                    <Button
                      variant="ghost"
                      className="w-full flex items-center justify-end gap-3 px-2 text-red-600 hover:bg-red-50"
                      onClick={logout}
                    >
                      <span>{t("logout")}</span>
                      <LogOut className="w-5 h-5" />
                    </Button>
                    <p
                      className="w-full text-end pe-2 pt-0.5 text-[10px] leading-none text-gray-400/90 tabular-nums"
                      dir="ltr"
                      title={BUILD_ID}
                    >
                      {formatBuildIdLabel()}
                    </p>
                  </div>
                </div>
              </SheetContent>
            </Sheet>

            <Link to={withActiveStoreInUrl(createPageUrl("Home"))} className="flex items-center gap-2">
    {/* אם הוא אדמין או מרלוג - נציג את שם התפקיד; מנהל סניף – לוגו הרשת מוסתר */}
    {isSystemAdmin ? (
        <div className="h-10 flex items-center justify-center bg-emerald-100 rounded-lg px-3 gap-2">
            <span className="text-emerald-700 font-bold text-sm">
            {currentUser?.role?.name || "מנהל מערכת"}
            </span>
            <Home className="w-4 h-4 text-emerald-700 hidden sm:block" />
        </div>
    ) : (
        /* לוגו הרשת מוסתר לפי בקשת המשתמש */
        null
    )}
</Link>
          </div>

          {headerSearchExpanded && showHeaderSearch ? (
            <div className="flex-1 min-w-0 px-1">
              <HeaderQuickProductSearch
                products={prefetched?.products ?? []}
                storeId={storeId}
                canEditCart={effectiveCartAccess === "edit"}
                expanded
                onExpandedChange={setHeaderSearchExpanded}
              />
            </div>
          ) : (
          <div className="ms-auto flex items-center gap-0 min-w-0">
  {/* סינון קטגוריות – רק בדף קטגוריות ובדף מוצרי קטגוריה */}
  {isCategoriesOrCategoryProducts && (
    <Sheet open={isCategoryFilterOpen} onOpenChange={setIsCategoryFilterOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="relative min-h-11 min-w-11" title="סינון">
          <Filter className="w-5 h-5 text-gray-600" />
          {categoryFilter.activeFiltersCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-emerald-600 text-white text-[10px] font-bold px-1">
              {categoryFilter.activeFiltersCount}
            </span>
          )}
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="w-[min(100vw,360px)] p-0 flex flex-col bg-gray-50/95"
        aria-describedby={undefined}
      >
        <div className="p-5 border-b bg-white shadow-sm">
          <SheetTitle asChild>
            <h2 className="text-lg font-bold text-gray-900 text-right">סינון מוצרים</h2>
          </SheetTitle>
          {isCategoryProductsPage ? (
            <p className="text-sm text-gray-500 text-right mt-0.5">בחר סינונים וסדר תצוגה</p>
          ) : null}
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-8">
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-right">
              <Filter className="w-4 h-4 text-emerald-600 shrink-0" />
              <span className="font-semibold text-gray-800">סינון לפי סוג</span>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white overflow-hidden divide-y divide-gray-100">
              {showKosherPassoverLabel && (
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-passover" checked={categoryFilter.showPassover} onCheckedChange={categoryFilter.setShowPassover} className="shrink-0" />
                <MatzahIcon className="w-4 h-4 text-amber-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">כשר לפסח</span>
              </label>
              )}
              {showBakedAfterPassoverLabel && (
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-baked-after-passover" checked={categoryFilter.showBakedAfterPassover} onCheckedChange={categoryFilter.setShowBakedAfterPassover} className="shrink-0" />
                <Flame className="w-4 h-4 text-orange-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">{BAKED_AFTER_PASSOVER_LABEL}</span>
              </label>
              )}
              {!isBranchSession && (
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-returned-stock" checked={categoryFilter.showReturnedToStock} onCheckedChange={categoryFilter.setShowReturnedToStock} className="shrink-0" />
                <Package className="w-4 h-4 text-emerald-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">חזר למלאי</span>
              </label>
              )}
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-returned-assortment" checked={categoryFilter.showReturnedToAssortment} onCheckedChange={categoryFilter.setShowReturnedToAssortment} className="shrink-0" />
                <LayoutGrid className="w-4 h-4 text-violet-600 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">חזר למגוון</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-promotions" checked={categoryFilter.showPromotions} onCheckedChange={categoryFilter.setShowPromotions} className="shrink-0" />
                <Tag className="w-4 h-4 text-amber-500 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">הצג מבצעים</span>
              </label>
              <label className="flex items-center gap-3 p-4 cursor-pointer hover:bg-gray-50 transition-colors">
                <Checkbox id="layout-filter-new" checked={categoryFilter.showNew} onCheckedChange={categoryFilter.setShowNew} className="shrink-0" />
                <Sparkles className="w-4 h-4 text-blue-500 shrink-0" />
                <span className="font-medium text-gray-700 flex-1 text-right">הצג מוצרים חדשים</span>
              </label>
            </div>
          </div>

          {isCategoryProductsPage && (
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-right">
                <ArrowDownAZ className="w-4 h-4 text-emerald-600 shrink-0" />
                <span className="font-semibold text-gray-800">מיון</span>
              </div>
              <div className="space-y-2">
                <button
                  type="button"
                  onClick={() => categoryFilter.setProductSortMode("default")}
                  className={`w-full flex items-center gap-3 p-3 rounded-xl border text-right transition-all ${
                    categoryFilter.productSortMode === "default"
                      ? "border-emerald-500 bg-emerald-50 shadow-sm"
                      : "border-gray-200 bg-white hover:border-emerald-200 hover:bg-emerald-50/50"
                  }`}
                >
                  <span className="flex-1 font-medium text-gray-700">סדר מערכת (ברירת מחדל)</span>
                </button>
                <button
                  type="button"
                  onClick={() => categoryFilter.setProductSortMode("alphabetical")}
                  className={`w-full flex items-center gap-3 p-3 rounded-xl border text-right transition-all ${
                    categoryFilter.productSortMode === "alphabetical"
                      ? "border-emerald-500 bg-emerald-50 shadow-sm"
                      : "border-gray-200 bg-white hover:border-emerald-200 hover:bg-emerald-50/50"
                  }`}
                >
                  <span className="flex-1 font-medium text-gray-700">לפי א-ב (שם)</span>
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="p-5 border-t bg-white flex gap-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => {
              categoryFilter.setShowPromotions(false);
              categoryFilter.setShowNew(false);
              categoryFilter.setShowPassover(false);
              categoryFilter.setShowBakedAfterPassover(false);
              categoryFilter.setShowReturnedToStock(false);
              categoryFilter.setShowReturnedToAssortment(false);
              categoryFilter.setProductSortMode("default");
            }}
          >
            נקה הכל
          </Button>
          <Button className="flex-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => setIsCategoryFilterOpen(false)}>
            סגור
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  )}

  {/* קטגוריות (Sheet) */}
  {/* <Sheet open={categoriesOpen} onOpenChange={setCategoriesOpen}>
    <SheetTrigger asChild>
      <Button variant="ghost" size="icon">
        <Grid3X3 className="w-5 h-5 text-gray-600" />
      </Button>
    </SheetTrigger>
    <SheetContent side="right" className="w-80 overflow-y-auto [&>button]:left-4 [&>button]:right-auto">
      <SheetHeader>
        <SheetTitle className="text-right">{t("allCategories")}</SheetTitle>
      </SheetHeader>

      <div className="mt-6 space-y-3">
        {mainCategories.map((mainCat) => {
          const subCats = getSubCategories(mainCat.id);
          return (
            <div key={mainCat.id} className="border rounded-lg overflow-hidden">
              <Link
                to={createPageUrl(`CategoryProducts?id=${mainCat.id}`)}
                onClick={() => setCategoriesOpen(false)}
              >
                <div className="bg-emerald-600 hover:bg-emerald-700 transition-colors p-3 flex items-center justify-between cursor-pointer">
                  <ChevronLeft className="w-4 h-4 text-white" />
                  <span className="font-bold text-white">{mainCat.name}</span>
                </div>
              </Link>

              {subCats.length > 0 && (
                <div className="p-2 bg-gray-50 space-y-1">
                  {subCats.map((subCat) => (
                    <Link
                      key={subCat.id}
                      to={createPageUrl(`CategoryProducts?id=${subCat.id}`)}
                      onClick={() => setCategoriesOpen(false)}
                    >
                      <div className="px-3 py-2 text-sm hover:bg-emerald-50 rounded transition-colors cursor-pointer text-right">
                        {subCat.name}
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </SheetContent>
  </Sheet> */}

  {/* סל והתראות – צמודים לצד השמאלי (ms-auto ב-RTL דוחף לשמאל) */}
  <div className="flex items-center gap-0">
    {showHeaderSearch ? (
      <HeaderQuickProductSearch
        products={prefetched?.products ?? []}
        storeId={storeId}
        canEditCart={effectiveCartAccess === "edit"}
        expanded={false}
        onExpandedChange={setHeaderSearchExpanded}
      />
    ) : null}
    <Link to={createPageUrl("Notifications")}>
      <Button variant="ghost" size="icon" className="relative">
        <Bell className="w-5 h-5 text-gray-600" />
        {unreadCount > 0 && (
          <span className="pointer-events-none absolute -top-1 -right-1 z-10 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">
            {unreadCount}
          </span>
        )}
      </Button>
    </Link>

    <Button
      type="button"
      variant="ghost"
      size="icon"
      title="רענון חזק"
      aria-label="רענון חזק"
      disabled={isHardRefreshing}
      onClick={handleHardRefresh}
      className="shrink-0"
    >
      <RefreshCw className={`w-5 h-5 text-gray-600 ${isHardRefreshing ? "animate-spin" : ""}`} />
    </Button>

    {(isStoreManager || isActingAsStore) && effectiveCartAccess !== 'none' && (
      <Link to={withActiveStoreInUrl(createPageUrl("Cart"))}>
        <Button variant="ghost" size="icon" className="relative" data-cart-icon>
          <motion.div
            key={cartCount}
            initial={{ scale: 1 }}
            animate={{ scale: cartCount > 0 ? [1, 1.4, 1] : 1 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <ShoppingCart className="w-5 h-5 text-gray-600" />
          </motion.div>
          {cartCount > 0 && (
            <motion.div
              key={`badge-${cartCount}`}
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="absolute -top-1 -right-1 w-5 h-5 p-0 flex items-center justify-center bg-emerald-600 text-white text-[10px] font-bold rounded-full shadow-sm"
            >
              {cartCount}
            </motion.div>
          )}
        </Button>
      </Link>
    )}
  </div>
          </div>
          )}
  {/* התנתקות */}
  {/* <Button variant="ghost" size="icon" onClick={logout} title={t("logout")}>
    <LogOut className="w-5 h-5 text-red-500" />
  </Button> */}
</div>

        {isActingAsStore && actingStoreDisplayName && !isAreaManagerStorePicker ? (
          <div className="border-t border-cyan-100 bg-cyan-50 px-3 py-1.5">
            <div className="mx-auto flex max-w-lg items-center justify-center gap-2 text-xs text-cyan-900">
              <span className="min-w-0 truncate">
                מחובר כמנהל סניף: <span className="font-bold">{actingStoreDisplayName}</span>
              </span>
              <Button
                type="button"
                variant="outline"
                size="sm"
                className="h-6 shrink-0 px-2 border-cyan-200 text-cyan-800 hover:bg-cyan-100 text-xs"
                onClick={() => {
                  exitStore();
                  navigate("/AreaManagerStores");
                }}
              >
                התנתקות
              </Button>
            </div>
          </div>
        ) : null}
      </header>
      )}

      {/* Desktop Sidebar — fixed, בתוך ה-layout (לא portal) */}
      {!isAreaManagerHub && (
      <aside
        dir="rtl"
        className="hidden lg:flex lg:flex-col lg:fixed lg:top-[65px] lg:right-0 lg:z-30 lg:w-64 lg:h-[calc(var(--app-vh,100dvh)-65px)] lg:overflow-hidden lg:border-l lg:border-gray-100 lg:bg-white"
      >
        <nav className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain py-4">
          {displayMenuItems.map((item) => {
            const url = createPageUrl(item.page);
            const toUrl = withActiveStoreInUrl(url);
            const isCurrentPage = location.pathname === url || location.pathname === url + "/";
            return (
              <Link
                key={item.page}
                to={toUrl}
                onClick={() => handleMenuNavigation(item.page, isCurrentPage)}
                className={`flex items-center justify-start gap-3 px-6 py-3 transition-colors ${
                  isMenuItemActive(item.page)
                    ? "bg-emerald-50 text-emerald-700 border-r-4 border-emerald-600"
                    : "text-gray-600 hover:bg-gray-50"
                }`}
              >
                <item.icon className="w-5 h-5" />
                <span className="font-medium">{item.name}</span>
              </Link>
            );
          })}
        </nav>
        <div className="flex shrink-0 flex-col gap-1 border-t bg-white p-4">
          <Button
            type="button"
            variant="ghost"
            className="flex w-full items-center justify-start gap-3 px-2 text-emerald-700 hover:bg-emerald-50"
            onClick={openSupportContact}
          >
            <Phone className="w-5 h-5 shrink-0" />
            <span className="font-medium" dir="rtl">
              נתקלת בבעיה{"\u200F"}?
            </span>
          </Button>
          {isActingAsStore && !isAreaManagerStorePicker ? (
            <Button
              variant="outline"
              className="flex w-full items-center justify-start gap-3 px-2 border-cyan-200 text-cyan-800 hover:bg-cyan-50"
              onClick={() => {
                exitStore();
                navigate("/AreaManagerStores");
              }}
            >
              <span>התנתקות מהסניף</span>
            </Button>
          ) : null}
          <PwaInstallMenuItem layout="sidebar" />
          <Button
            variant="ghost"
            className="flex w-full items-center justify-start gap-3 px-2 text-red-600 hover:bg-red-50"
            onClick={logout}
          >
            <LogOut className="w-5 h-5" />
            <span>{t("logout")}</span>
          </Button>
          <p
            className="w-full text-start ps-2 pt-0.5 text-[10px] leading-none text-gray-400/90 tabular-nums"
            dir="ltr"
            title={BUILD_ID}
          >
            {formatBuildIdLabel()}
          </p>
        </div>
      </aside>
      )}

      <main
        className={`min-h-0 min-w-0 max-w-full flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain w-full box-border bg-gradient-to-br from-emerald-50 via-teal-50 to-blue-50 ${
          isAreaManagerHub ? "" : "lg:pr-64"
        }`}
      >
        {currentPageName === "Users" ? (
          <div className="px-4 pt-3 max-w-4xl mx-auto">
            <SystemUpdateStories />
          </div>
        ) : null}
        {children}
      </main>
      <PushNotificationPrompt enabled={isBranchSession && !isSystemAdmin && !isAreaManagerHub} />
      <CustomMessagePopup
        show={!!popupNotification}
        notification={popupNotification}
        onClose={handleCloseMessagePopup}
        onAcknowledge={handleAcknowledgePopup}
      />
      <SupportContactPopup
        show={supportContactOpen}
        phone={supportPhone}
        whatsapp={supportWhatsapp}
        onClose={() => setSupportContactOpen(false)}
      />
    </div>
    </HeaderQuickSearchOverlayProvider>
  );
}
